module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/C53Dez/media/FC-9781398490345.jpg?1670934262607",
      "alt": "This image is the cover for the book The Visitors – Version 2"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Visitors – Version 2\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Two time-travelling aliens, Bjorn and Zorn, witness the destruction of the Earth in 2052. They believe the Earth has been destroyed by religious zealots. Their investigation reveals one of their own is behind it. The intended goal was to hide the Earth from the universe. With Tasmania up for grabs, the chess game begins. They travel in time to collect a little band of misfits, to help them save humanity from its religious wars. The laid back Ptoni the Pteranodon, the ladylike Florence the Jersey Cow, the excitable Penelope the Adelie Penguin, and the Chicken Nugget obsessed Dax the Maine Coon Cat, set off on an adventure that will see them cross the galaxy and back again. Their adventure is filled with drama, fun and chaos. The local drive-thru will never be the same again, and neither will Florence’s derriere. Alien abduction can be fun!")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Andrew Cahill-Lloyd\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Andrew Cahill-Lloyd is an Aussie lyricist, a script writer, and an author. He spent 10 years as a serving member in the RAAF, from 1981 to 1992. He has a keen interest in marine life and enjoys his marine fish tank. Andrew is a qualified veterinary nurse, and he is also a champion for animal rights and encourages people to adopt from animal shelters. Dax The Maine Coon Cat was adopted from an animal shelter. Andrew is a grandfather to nine girls and a boy.!")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0